export enum SurvivorshipTypes {
  MOST_RECENT = "most-recent",
  OLDEST = "oldest",
  MOST_FREQUENT = "most-frequent",
  ARRAY = "array",
  MIN = "min",
  MAX = "max",
  SOURCE_PRIORITY = "source-priority",
}

export const SURVIVORSHIP_TYPES = Object.values(SurvivorshipTypes);

export enum SourceSurvivorshipTypes {
  MOST_RECENT = "most-recent",
  OLDEST = "oldest",
  MOST_FREQUENT = "most-frequent",
}

export const SOURCE_SURVIVORSHIP_TYPES = Object.values(SourceSurvivorshipTypes);

export enum BaseRecordSurvivorshipTypes {
  OLDEST = "oldest",
  MOST_RECENT = "most-recent",
}

export const BASE_RECORD_SURVIVORSHIP_TYPES = Object.values(
  BaseRecordSurvivorshipTypes,
);
